/* eslint-disable no-param-reassign */

/**
 * Takes a video element and adds some methods to it in order to make its controls similar to those of YouTube API.
 *
 * @param {object} player - The video element.
 */
const setYouTubeAPIVideoControls = player => {
  // Volume controls
  player.mute = () => {
    player.muted = true;
  };
  player.unMute = () => {
    player.muted = false;
  };

  // Speed controls
  player.playVideo = () => player.play();
  player.pauseVideo = () => player.pause();
  player.getAvailablePlaybackRates = () => [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
  player.setPlaybackRate = playbackRate => {
    player.playbackRate = playbackRate;
  };

  // Time Controls
  player.getDuration = () => player.duration;
  player.getCurrentTime = () => player.currentTime;
  player.seekTo = currentTime => {
    player.currentTime = currentTime;
  };

  // Quality controls
  player.setPlaybackQuality = () => {};

  // DOM node controls
  player.f = {
    getBoundingClientRect: () => player.getBoundingClientRect()
  };
};

export default setYouTubeAPIVideoControls;
